import { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField
} from "@mui/material";
import API from "../../config/api";
import { useIsMobile } from "../../hooks/useIsMobile";

const MembersRecurring = () => {
  const [members, setMembers] = useState([]);
  const isMobile = useIsMobile();
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = () => {
    setOpenDialog(false)
  }

  useEffect(() => {
    (async () => {
      const recurring = await API.get("member/members_recurring");
      console.log("RECUR---", recurring);
      setMembers(recurring.body.data);
    })();
  }, []);

  console.log("IS MOBILE---", isMobile);
  return (
    <div>
      <h4>Lista de recurrentes</h4>
      <div>Total: {members.length}</div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Nombres</TableCell>
              {!isMobile ? (
                <TableCell>Apellidos</TableCell>
              ) : null}
              <TableCell>Código Colegio</TableCell>
              <TableCell>Cédula</TableCell>
              <TableCell>Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members?.length > 0
              ? members.map((member, idx) => {
                  return (
                    <TableRow
                      key={`${member.id}`}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {member.names} {isMobile ? member.familyName : ""}
                      </TableCell>
                      {!isMobile ? (
                        <TableCell>{member.familyName}</TableCell>
                      ) : null}
                      <TableCell>{member.codeSchool}</TableCell>
                      <TableCell>{member.identifier}</TableCell>
                      <TableCell>
                        <Button onClick={() => setOpenDialog(true)}>Pagar cuotas</Button>
                      </TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={openDialog}
        onClose={handleClose}
      >
        <DialogTitle>Cuotas a pagar</DialogTitle>
        <DialogContent>
        <DialogContentText>
            Digitar la cantidad de coutas a cobrar.
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="quota"
            label="Cuotas"
            type="number"
            fullWidth
            variant="standard"
            value={1}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MembersRecurring;
